// extracted by mini-css-extract-plugin
module.exports = {"policy":"TermsAndConditions-module__policy___Anpnm","header":"TermsAndConditions-module__header___CHkxf"};